import { 
    GET_KOP_SURAT,
} from "shared/constants/ActionTypes";

const initialState = {
    dataKopSurat: null,
}

const KopSuratReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_KOP_SURAT:
            return {
                ...state,
                dataKopSurat : action.payload.results
            }
        default:
            return {
                ...state
            }
        }
    };

export default KopSuratReducer